export const ZAC_VERSION = {
    "version": "4.2.0"
};
